import { getParameterByName } from '../../Utils'

/**
 * Contains the initial state of the client.
 * @type {{win: number, muted: boolean, mutedSFX: boolean, mutedMusic: boolean, settingScreen: boolean, orientationChecked: boolean, swipePlea: boolean, assetProgress: {assets: number}, hideLoader: boolean, messages: Array, stepDebug: boolean, enableQuickspinCounter: number, quickSpinPromptShown: boolean, showQuickSpinPrompt: boolean, allowSpinRequests: boolean, _paused: boolean, paused: boolean, inFocus: boolean, restoreStateDisabled: boolean, hotzones: {ios: boolean, samsung: boolean}, settings: {}}}
 */
export default () => {
  const initialBaseState = {
    loading: true,
    win: 0,
    muted: true,
    mutedSFX: false,
    mutedMusic: false,
    hasSplash: false,
    hideSplash: getParameterByName('disableSplash') === 'true',
    hasIntro: false,
    hideIntro: (getParameterByName('disableIntro') === 'true' || config.skipIntroVideo),
    introLoaded: false,
    settingScreen: false,
    orientationChecked: false,
    swipePlea: true,
    assetProgress: { assets: 0 },
    hideLoader: false,
    messages: [],
    externalErrorHandling: false,
    stepDebug: false,
    enableQuickspinCounter: 0,
    quickSpinPromptShown: false,
    showQuickSpinPrompt: false,
    allowSpinRequests: false,
    _paused: false,
    paused: false,
    didCallGameFinished: false,
    inFocus: true,
    delayingSpin: false,
    restoreStateDisabled: false,
    hotzones: {
      ios: false,
      samsung: false,
    },
    gamespeed: 1,
    settings: {},
    fallbackResponse: {},
    sideGames: [],
    demo: [],
    demoIndex: 0,
    menuOpacity : 0.85,

    // POSTMESSAGE
    externalPauseRequest: false,
    externalPause: false,
    gameIsReady: false,
    rcIntervalEnabled: false,
  }

  return initialBaseState
}
